import { useLocation } from "@tanstack/react-router";

/** History `state.from` for back navigation, using TSR location instead of `window.location` (see `getRouteWithPrevLocation`). */
export const usePreviousLocationState = () => {
  const { path, query } = useLocation({
    select: location => ({
      path: location.pathname,
      query: location.searchStr,
    }),
  });

  return {
    from: {
      path,
      query,
    },
  };
};
